import styled from "styled-components";

const CommunityInfo = styled.div`
  width: 100%;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-bottom: 1px solid #f1f3f5;

  p {
    font-weight: 400;
    color: #222529;
    font-size: 0.875rem;
    max-width: 250px;
  }

  p:first-child {
    /* margin-top: 40px; */
  }

  button {
    cursor: pointer;
    border-radius: 8px;
    border: 0;
    background-color: #ff7a00;
    color: white;
    font-size: 0.875rem;
    font-weight: bold;
    width: 100%;
    padding: 12px 0;
    max-width: 250px;
    margin: 16px 0 42px 0;
  }
`;

export { CommunityInfo };